import React from "react";
import { ParagraphPracticeWorkspace } from "./ParagraphPracticePage";
export default function ParagraphPracticeEmbedPage() { return <ParagraphPracticeWorkspace embed />; }
